import types from './types';

import { ICreditError } from './reducers';
import CreditModel from 'src/model/credit.model';
import creditsPaymentsService from 'src/services/creditsPayments/creditsPayments';
import { paymentsSel } from './selectors';

const getCredits = (
  page: number,
  status: 'PENDING' | 'VOID' | 'DISPOSED',
  sortBy?: string
) => (dispatch: any) => {
  dispatch(setIsPending(true));
  dispatch(setError());
  dispatch(setStatusFilter(status));

  creditsPaymentsService
    .getPayments(page, status, sortBy)
    .then(res => {
      dispatch(setPayments(res.data));
      dispatch(setPageNumber(res.pageNumber));
      dispatch(setPageSize(res.pageSize));
      dispatch(setTotalElements(res.totalElements));
      dispatch(setTotalPages(res.totalPages));
      dispatch(setIsPending(false));
    })
    .catch(error => {
      dispatch(setIsPending(false));
      dispatch(
        setError({
          hasFailed: true,
          message: error.message
        })
      );
    });
};

const disposeCredit = (id: number, taker: string, note: string) => (
  dispatch: any,
  getState: any
) => {
  dispatch(setIsPending(true));
  dispatch(setError());

  creditsPaymentsService
    .disposePayment(id, taker, note)
    .then(res => {
      dispatch(getCredits(0, null, 'pmtDate,desc'));
    })
    .catch(error => {
      dispatch(setIsPending(false));
      dispatch(
        setError({
          hasFailed: true,
          message: error.message
        })
      );
    });
};

const voidCredit = (id: number, note: string) => (
  dispatch: any,
  getState: any
) => {
  dispatch(setIsPending(true));
  dispatch(setError());

  creditsPaymentsService
    .voidPayment(id, note)
    .then(res => {
      dispatch(getCredits(0, null, 'pmtDate,desc'));
    })
    .catch(error => {
      dispatch(setIsPending(false));
      dispatch(
        setError({
          hasFailed: true,
          message: error.message
        })
      );
    });
};

const setPayments = (payments: CreditModel[]) => {
  return { type: types.SET_CREDITS_PAYMENTS, payload: payments };
};

const setStatusFilter = (statusFilter: 'PENDING' | 'VOID' | 'DISPOSED') => {
  return { type: types.SET_CREDITS_STATUS_FILTER, payload: statusFilter };
};

const setPageNumber = (pageNumber: number) => {
  return { type: types.SET_CREDITS_PAGE_NUMBER, payload: pageNumber };
};

const setPageSize = (pageSize: number) => {
  return { type: types.SET_CREDITS_PAGE_SIZE, payload: pageSize };
};

const setTotalElements = (totalElements: number) => {
  return { type: types.SET_CREDITS_TOTAL_ELEMENTS, payload: totalElements };
};

const setTotalPages = (totalPages: number) => {
  return { type: types.SET_CREDITS_TOTAL_PAGES, payload: totalPages };
};

const setIsPending = (isPending: boolean) => {
  return { type: types.SET_CREDITS_IS_PENDING, payload: isPending };
};

const setError = (error?: ICreditError) => {
  return {
    type: types.SET_CREDITS_ERROR,
    payload: error
      ? error
      : {
          hasFailed: false,
          message: ''
        }
  };
};

export default {
  getCredits,
  disposeCredit,
  voidCredit
};
